import makeStyles from '@mui/styles/makeStyles';

export const useStyles = makeStyles((theme) => ({
  wrapper: {
    marginTop: theme.spacing(-1.5),
  },
}));
